import React from 'react';
import { storiesOf } from '@storybook/react';
import CreditorsResultRow from './CreditorsResultRow';
import { RowHeader } from '../EntriesResults';

storiesOf('Advanced Search/Result Rows', module)
  .add('Creditors', () => (
    <div className="result-item">
      <RowHeader row={row} />
      <div className="result-item-body">
        <CreditorsResultRow row={row} />
      </div>
    </div>
  ));

const row = {
  address: "c/o Daniel L. Goodkin↵1875 Century Park East, Suite 1860↵Los Angeles, CA 90067",
  case: {case_court: "nysbke", type_code: 0, schedule_ab: null, case_naics_code: null},
  case_assets: "Unknown",
  case_chapter: 11,
  case_court: "nysbke",
  case_date_filed: "03/10/2014",
  case_judge_name: "Martin Glenn",
  case_liabilities: "Unknown",
  case_naics_code: null,
  case_nature_of_suit_code: null,
  case_no: "1:14-bk-10557",
  case_title: "Sbarro LLC",
  case_type: "bk",
  case_uuid: "nysbke_247775",
  creditor_code: "6449847",
  creditor_role: "cr",
  date_filed: "08/29/2019",
  document_type: "creditors",
  id: "creditors:nysbke_247775--6449847",
  index_timestamp: 1567082848,
  modified: "2014-03-16 18:27:19.420753+00",
  name: "5060 Montclair Plaza Lane Owner, LLC",
  query: "creditors",
  timestamp: 1567082848,
  type_code: 5,
};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/CreditorsResultRow.stories.jsx